module.exports = __webpack_public_path__ + "img/placeholdeer.569b53cc.jpg";